import { Form } from 'antd';
import { FC, memo, useCallback, useState } from 'react';

import { AppMessage } from '@/common/components';
import { FormFieldsErrors } from '@/common/interfaces';
import { extractFormErrors, messageOnError } from '@/common/utils';

import { DomainRegistrarAccountFormFields, DomainRegistrarAccountsFormInputs, useEditDomainRegistrarAccountsMutation } from '@/modules/DomainRegistrars';

import { DomainRegistrarAccountsFormView } from './DomainRegistrarAccountsFormView';
import { domainRegistrarAccountFormValidationSchema } from './validation';

interface Props {
  domainRegistrarId: string;
}

export const DomainRegistrarAccountsEditFormContainer: FC<Props> = memo(({ domainRegistrarId }) => {
  const appMessageApi = AppMessage.useControls();
  const [form] = Form.useForm<DomainRegistrarAccountFormFields>();
  const [formErrors, setFormErrors] = useState<FormFieldsErrors<typeof DomainRegistrarAccountsFormInputs>>(null);

  const { mutate: editDomainRegistrarAccountMutation, isLoading: editDomainRegistrarAccountIsLoading } =
    useEditDomainRegistrarAccountsMutation(domainRegistrarId)({
      onError: (err) => {
        setFormErrors(extractFormErrors<typeof DomainRegistrarAccountsFormInputs>(err));
        messageOnError(err, appMessageApi);
      }
    });

  // TODO: fetch account useQuery

  const initialValues: DomainRegistrarAccountFormFields = { login: undefined, password: undefined };

  const handleFinish = useCallback((values: DomainRegistrarAccountFormFields): void => {
    setFormErrors(null);
    editDomainRegistrarAccountMutation(values);
  }, []);

  const handleBack = useCallback(() => {}, []);

  const handleFinishFailed = useCallback((): void => {
    setFormErrors(null);
  }, []);

  return (
    <DomainRegistrarAccountsFormView
      form={ form }
      formName={ 'domain-registrar-account-edit' }
      formType={ 'edit' }
      initialValues={ initialValues }
      isFormLoading={ editDomainRegistrarAccountIsLoading }
      validationSchema={ domainRegistrarAccountFormValidationSchema }
      formErrors={ formErrors }
      handleBack={ handleBack }
      handleFinish={ handleFinish }
      handleFinishFailed={ handleFinishFailed }
    />
  );
});
